<proffeo-ui-page-wrapper>
  <div class="flex h-full min-h-0 w-full flex-col gap-4 overflow-y-auto pt-3 sm:px-5 sm:pb-5 lg:rounded-md lg:pt-6">
    <div class="flex shrink-0 flex-row gap-4">
      <date-range-selector
        [(selectedTimeMode)]="selectedTimeMode"
        [(selectedDateRange)]="selectedDateRange"
      />
      <time-period-selector [(selectedTimeMode)]="selectedTimeMode" />
    </div>

    <div class="flex w-full max-w-full shrink-0 items-center justify-center overflow-x-hidden">
      @if (selectedTimeMode() === SelectedTimeReportTypeEnum.RANGE) {
        <date-range-input
          [(selectedTimeMode)]="selectedTimeMode"
          [(dateRangeSelected)]="selectedDateRange"
        />
      } @else {
        <timeline-scroller
          [(selectedYear)]="selectedYear"
          [(selectedMonth)]="selectedMonth"
          [(selectedWeek)]="selectedWeek"
          [(selectedDay)]="selectedDay"
          [selectedTimeMode]="selectedTimeMode()"
        />
      }
    </div>

    <div class="flex w-full flex-col gap-4">
      <div class="flex w-full flex-col-reverse lg:flex-row">
        <sum-up-hours-panel
          [summary]="sumUp()"
          class="flex-none lg:flex-[0.4] flex justify-center items-end w-full pt-4 lg:pt-0"
        />
        @if (!isMobile()) {
          <div class="flex-1 h-[150px] w-full my-4">
            <app-time-report-panel-chart
              [filteredWorkTimeReports]="chartWorkTimeReports()"
              [flattenedWorkTimeReports]="flattenedFilteredReports()"
              [mixedChartView]="mixedChartView()"
              [selectedMode]="selectedTimeMode()"
              [availableUsers]="availableUsers()"
              [selectedYear]="selectedYear()"
              [selectedMonth]="selectedMonth()"
              [selectedWeek]="selectedWeek()"
              [selectedDay]="selectedDay()"
            />
          </div>
        }
      </div>

      @if (!isMobile()) {
        <div class="py-4">
          <proffeo-time-report-panel-filters
            (changeGroupingMode)="changeGroupingMode($event)"
            (expandAll)="expandAllSessions()"
            (hideAll)="hideAllSessions()"
            (addReport)="addReport()"
            (approveReports)="approveSelectedReports()"
            [selectedTimeReportIds]="selectedTimeReportIds()"
            [selectedGroupingMode]="groupingMode()"
            [sessionsToggled]="isExpandedAll()"
            [filteredTimeReports]="filteredWorkTimeReports()"
            [flattenedTimeReports]="flattenedFilteredReports()"
            [visibleTableColumns]="visibleTableColumns()"
          />
        </div>
      }

      <proffeo-reports-table-toolbar
        (changeGroupingMode)="changeGroupingMode($event)"
        (expandAll)="expandAllSessions()"
        (hideAll)="hideAllSessions()"
        (addReport)="addReport()"
        (approveReports)="approveSelectedReports()"
        (clearFilters)="clearFilters()"
        [selectedTimeReportIds]="selectedTimeReportIds()"
        [selectedGroupingMode]="groupingMode()"
        [sessionsToggled]="isExpandedAll()"
        [timeReportRows]="tableRows()"
        [visibleTableColumns]="visibleTableColumns()"
      />

      @if (groupingMode() === GroupingModeEnum.NONE) {
        <proffeo-flat-reports-table
          (selectedTimeReportIdsChanged)="onSelectedTimeReportIdsChanged($event)"
          (editReport)="onEditReport($event)"
          (deleteReport)="onDeleteReport($event)"
          (taskDetailsOpened)="openTaskDetailsById($event)"
          [flattenedWorkTimeReports]="tableRows()"
          [selectedTimeReportIds]="selectedTimeReportIds()"
          [selectionDisabled]="approvalInProgress()"
          [selectableReportIds]="eligibleApprovalIds()"
          class="block"
        />
      } @else {
        <proffeo-grouped-reports
          (selectedTimeReportIdsChanged)="onSelectedTimeReportIdsChanged($event)"
          (reportEdited)="onEditReport($event)"
          (reportDeleted)="onDeleteReport($event)"
          (taskDetailsOpened)="openTaskDetailsById($event)"
          [rows]="tableRows()"
          [groupingMode]="groupingMode()"
          [isExpandedAll]="isExpandedAll()"
          [selectedReportIds]="selectedTimeReportIds()"
          [selectionDisabled]="approvalInProgress()"
          [selectableReportIds]="eligibleApprovalIds()"
          class="block"
        />
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
